import { getMyUserId } from '@/store/memberships'

export function canViewResults(poll) {
	// closed polls can always see results
	if (poll.closed) return true
	// poll creator can always see results
	if (poll.user_id === getMyUserId()) return true
	// 'always' means anyone can see results at any time
	if (poll.reveal_timing === 'always') return true
	// for 'after_vote', current user has to have voted
	if (poll.reveal_timing === 'after_vote')
		return poll.options?.some((o) => o.voted) ?? false
	// for 'after_close', poll has to be closed, which it isn't
	if (poll.reveal_timing === 'after_close') return false
	return false
}
